import { GlideTextCell } from "./GlideTextCell.js";
class GlideLocalizedTextCell extends GlideTextCell {
  _formatter;
  constructor(valueGetter, formatter, emptySymbol) {
    super(valueGetter, emptySymbol);
    this._formatter = formatter;
  }
  formatValue(value) {
    return value ? this._formatter(value) : null;
  }
}
export {
  GlideLocalizedTextCell
};
//# sourceMappingURL=GlideLocalizedTextCell.js.map
